import React from "react";

const styles = `
  @keyframes wa-pulse {
    0%   { transform: scale(1);   opacity: 0.7; }
    70%  { transform: scale(1.6); opacity: 0;   }
    100% { transform: scale(1.6); opacity: 0;   }
  }
  @keyframes wa-bounce {
    0%, 100% { transform: translateY(0);   }
    50%       { transform: translateY(-6px); }
  }
  .wa-pulse::before,
  .wa-pulse::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 9999px;
    background: #22c55e;
    animation: wa-pulse 2s ease-out infinite;
  }
  .wa-pulse::after {
    animation-delay: 0.6s;
  }
  .wa-icon {
    animation: wa-bounce 2.5s ease-in-out infinite;
  }
  .wa-icon:hover {
    animation: none;
    transform: scale(1.12);
    transition: transform 0.2s ease;
  }
`;

export default function FloatingWhatsApp() {
  return (
    <>
      <style>{styles}</style>
      <a
        href="https://wa.me/256752873187"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="wa-icon fixed z-50 flex items-center justify-center"
        style={{
          bottom: "clamp(16px, 4vw, 28px)",
          right:  "clamp(16px, 4vw, 28px)",
          width:  "clamp(48px, 8vw, 60px)",
          height: "clamp(48px, 8vw, 60px)",
        }}
      >
        {/* Pulsing rings */}
        <span
          className="wa-pulse absolute inset-0 rounded-full"
          style={{ zIndex: -1 }}
        />

        {/* Button */}
        <span
          className="w-full h-full rounded-full bg-green-500 flex items-center justify-center shadow-xl"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            style={{ width: "clamp(24px, 4.5vw, 32px)", height: "clamp(24px, 4.5vw, 32px)" }}
            className="fill-white"
          >
            <path d="M16 .396C7.163.396 0 7.56 0 16.396c0 2.82.737 5.57 2.136 8.002L0 32l7.823-2.053A15.94 15.94 0 0016 32c8.837 0 16-7.163 16-16S24.837.396 16 .396zm0 29.09a13.04 13.04 0 01-6.645-1.82l-.475-.282-4.64 1.218 1.237-4.522-.309-.463a13.028 13.028 0 01-2.01-7.22c0-7.19 5.85-13.04 13.04-13.04 7.19 0 13.04 5.85 13.04 13.04 0 7.19-5.85 13.04-13.04 13.04zm7.145-9.79c-.392-.196-2.317-1.144-2.676-1.275-.36-.13-.622-.196-.883.196-.261.392-1.014 1.275-1.243 1.537-.229.261-.457.294-.85.098-.392-.196-1.655-.61-3.152-1.947-1.164-1.039-1.95-2.322-2.178-2.714-.229-.392-.024-.604.172-.799.176-.175.392-.457.588-.686.196-.229.261-.392.392-.654.131-.261.066-.49-.033-.686-.098-.196-.883-2.121-1.21-2.904-.318-.764-.64-.66-.883-.673h-.752c-.261 0-.686.098-1.046.49-.359.392-1.373 1.34-1.373 3.269s1.406 3.792 1.602 4.053c.196.261 2.768 4.226 6.708 5.923.938.405 1.67.646 2.241.827.941.299 1.797.257 2.474.156.755-.113 2.317-.947 2.644-1.863.327-.915.327-1.699.229-1.863-.098-.163-.36-.261-.752-.457z"/>
          </svg>
        </span>
      </a>
    </>
  );
}